import { useEffect, useRef, useState } from 'react';
import { AdjustmentsHorizontalIcon } from '@heroicons/react/24/outline';
import { useGeoBrowseContext } from '../context/GeoBrowseContext';
import styles from '../GeoBrowse.module.css';

export default function SignificancePanel() {
  const { thresholds, draftPadj, draftFc, setDraftPadj, setDraftFc, applyThresholds } =
    useGeoBrowseContext();
  const [open, setOpen] = useState(false);
  const panelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return undefined;
    const handleClick = (e: MouseEvent) => {
      if (panelRef.current && !panelRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  const handleApply = () => {
    applyThresholds();
    setOpen(false);
  };

  return (
    <div className={styles.significanceWrap} ref={panelRef}>
      <button
        type="button"
        className={styles.significanceBtn}
        onClick={() => setOpen(v => !v)}
        aria-expanded={open}
      >
        <AdjustmentsHorizontalIcon width={16} height={16} aria-hidden />
        <span className={styles.significanceLabel}>Significance</span>
        <span className={styles.significanceValues}>
          padj ≤ {thresholds.padj} | |LFC| ≥ {thresholds.fc}
        </span>
      </button>

      {open && (
        <div className={styles.significancePopover}>
          <p className={styles.significancePopoverTitle}>Adjust significance thresholds</p>
          <div className={styles.significanceFields}>
            <label>
              padj threshold
              <input
                type="number"
                step="0.01"
                min="0"
                max="1"
                value={draftPadj}
                onChange={e => setDraftPadj(e.target.value)}
              />
            </label>
            <label>
              |log2FC| threshold
              <input
                type="number"
                step="0.1"
                min="0"
                value={draftFc}
                onChange={e => setDraftFc(e.target.value)}
              />
            </label>
          </div>
          <button type="button" className={styles.significanceApply} onClick={handleApply}>
            Apply
          </button>
        </div>
      )}
    </div>
  );
}
